import { Plus } from 'assets/icons';
import Button from 'components/button';
import CompactEmptyState from 'components/EmptyState/CompactEmptyState';
import useText from 'hooks/useText';
import { endSummary } from 'pages/prospection/callListItems';

/**
 * The call list with nothing left to call: `empty` (nothing made either) or
 * `finished` (with its reached and callbacks counts). Both lead to the global
 * list and to a new prospect.
 */
const CallListStates = ({ state, made, onOpenGlobal, onAddProspect }) => {
  const { text, plural } = useText('prospection');
  const finished = state === 'finished';
  const summary = finished ? endSummary(made) : null;

  return (
    <div className="flex flex-col items-center pb-6">
      <CompactEmptyState
        compact
        glyph={finished ? 'badgeCheck' : 'inbox'}
        title={text(finished ? 'finished.title' : 'empty.title')}
        description={text(finished ? 'finished.text' : 'empty.text')}
      />
      {summary && (
        <div className="-mt-4 mb-4 flex flex-wrap justify-center gap-2">
          {[
            plural('finished.reached', summary.reached),
            plural('finished.callbacks', summary.callbacks),
          ].map((label) => (
            <span
              key={label}
              className="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium leading-4 text-gray-700"
            >
              {label}
            </span>
          ))}
        </div>
      )}
      <div className="flex flex-wrap justify-center gap-3">
        <Button color="SECONDARY" size="SM" onClick={onOpenGlobal}>
          {text('states.globalList')}
        </Button>
        <Button color="PRIMARY" size="SM" onClick={onAddProspect}>
          <Plus wh={18} color="currentColor" />
          {text('states.addProspect')}
        </Button>
      </div>
    </div>
  );
};

export default CallListStates;
